import { FontAwesomeIcon as FA } from "@fortawesome/react-fontawesome";
import React from "react";
import "../css/table.css";

interface PaginationProps {
  total: number;
  offset: number;
  limit: number;
  setPaginationParams(offset: number, limit: number): void;
}

const Pagination = ({ total, offset, limit, setPaginationParams }: PaginationProps): JSX.Element => {
  const canMoveBack = offset > 0;
  const canMoveNext = offset + limit < total;

  const startItemIndex = offset < total ? offset + 1 : 0;
  const endItemIndex = offset + limit > total ? total : offset + limit;

  return (
    <div className="row flex-grow-1 my-1">
      {/* LEFT SIDE WITH ARROWS */}
      <div className="col-6 d-flex align-items-center">
        <button
          className="btn btn-sm btn-link ml-4 p-0"
          onClick={(): void => setPaginationParams(0, limit)}
          disabled={!canMoveBack}
          type="button"
        >
          <FA icon="angle-double-left" fixedWidth />
        </button>

        <button
          className="btn btn-sm btn-link m-0 p-0"
          onClick={(): void => setPaginationParams(offset - limit, limit)}
          disabled={!canMoveBack}
          type="button"
        >
          <FA icon="angle-left" fixedWidth />
        </button>

        <button
          className="btn btn-sm btn-link p-0 m-0"
          onClick={(): void => setPaginationParams(offset + limit, limit)}
          disabled={!canMoveNext}
          type="button"
        >
          <FA icon="angle-right" fixedWidth />
        </button>

        <button
          className="btn btn-sm btn-link m-0 p-0"
          onClick={(): void => setPaginationParams(offset + limit, limit)}
          disabled={!canMoveNext}
          type="button"
        >
          <FA icon="angle-double-right" fixedWidth />
        </button>

        <span className="ml-4 text-small text-secondary text-center ">
          {`${startItemIndex} to ${endItemIndex} from `}
          <span className="text-dark font-weight-bold">{total}</span>
        </span>
      </div>
      {/* END OF LEFT SIDE WITH ARROWS */}

      {/* RIGHT SIDE WITH LIMIT */}
      <div className="col-6 d-flex align-items-center justify-content-end">
        <span className="text-small text-secondary">Display</span>
        {[10, 25].map((size) => (
          <button
            type="button"
            className="btn btn-sm btn-link ml-2 p-0 "
            key={`pagination-limit-${size}`}
            onClick={(): void => setPaginationParams(0, size)}
            disabled={size === limit}
            style={{ color: "#1e1f1d" }}
          >
            {size}
          </button>
        ))}
        <div className="mr-4" />
      </div>
      {/* END OF RIGHT SIDE WITH LIMIT */}
    </div>
  );
};
export default Pagination;
